// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/textarea/Invalid.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextArea, css } from '@sail/ui';
import { EXAMPLE_TEXT } from './common';
export const Invalid = () => <TextArea label="Favorite word" defaultValue={EXAMPLE_TEXT} invalid css={{
  width: css.value('350px')
}} />;